import _ from 'lodash'
import Layout from "@/layout/Layout";
import globalStyle from '@/styles/Global.scss'
import React, {useEffect, useState} from "react";
import {exportSchedule, getScheduleList, importSchedule} from "@/api/schedule";
import {useHistory} from "react-router";
import MButton from "@/components/atom/MButton";
import {rangeOf} from "@/util/util";
import dayjs from "dayjs";
import {Schedule as ScheduleModel} from '@/entity/Schedule';
import ScheduleEditor from "@/components/schedule/ScheduleEditor";
import {saveDownloadFile} from "@/util/file";

const ScheduleEdit = () => {
  const history = useHistory()
  const [dateStart, setDateStart] = useState(0)
  const [dateOffset, setDateOffset] = useState(30)
  const [schedules, setSchedules] = useState([])
  const fileInput = React.createRef()

  useEffect(() => {
    (async () => {
      await loadSchedules()
    })()
  }, [])

  const toMenu = () => {
    history.push(`/menu`)
  }

  const loadSchedules = async () => {
    const schedules = await getScheduleList()
    setSchedules(schedules)
  }

  const todaySchedule = ({offset}) => {
    const targetDate = dayjs().subtract(offset, 'day')
    const formatTargetDate = targetDate.format('YYYY-MM-DD')
    return _.filter(schedules, (s) => {
        return formatTargetDate === s.formatedDate()
      })[0]
      || new ScheduleModel({date: targetDate.toDate()})
  }

  const makeDateOffsets = () => {
    return _.map(rangeOf(dateOffset), (r) => {
      return r + dateStart
    })
  }

  const expandOffset = (expand) => {
    if (expand < 0) {
      setDateStart(dateStart + expand)
    }
    setDateOffset(dateOffset + Math.abs(expand))
  }

  const onDidSave = async () => {
    await loadSchedules()
  }

  const download = async () => {
    const file = await exportSchedule()
    await saveDownloadFile(file, 'スケジュール.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
  }

  const doUploadFile = async (e) => {
    e.preventDefault()
    if (!e.target.files.length) {
      return
    }
    let file = e.target.files[0]
    let fr = new FileReader()
    fr.onload = async (event) => {
      const dataURI = event.target.result
      const content = dataURI.split(',')[1] || dataURI
      await importSchedule({content})
      await loadSchedules()
    }
    fr.readAsDataURL(file)
  }

  return (
    <>
      <Layout category={'WA'} title={'スケジュール'}>
        <div className={globalStyle.container}>
          <div>
            <MButton image={'download.png'} onClick={download} value={'ダウンロード'}></MButton>
          </div>
          <div>
            <MButton image={'upload.png'} onClick={() => {
              fileInput.current.click()
            }}></MButton>
            <input multiple type="file" ref={fileInput} className="input" onChange={doUploadFile}
                   style={{display: "none"}} accept={'*.xlsx'}/>
          </div>
          <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
          <h3>スケジュール</h3>
          <MButton image={'after30.png'} onClick={() => {
            expandOffset(-30)
          }}></MButton>
          {
            _.map(makeDateOffsets(), (offset) => {
              return <React.Fragment key={offset}>
                <ScheduleEditor schedule={todaySchedule({offset})} onDidSave={onDidSave}></ScheduleEditor>
              </React.Fragment>
            })
          }
          <MButton image={'before30.png'} onClick={() => {
            expandOffset(30)
          }}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={toMenu}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default ScheduleEdit
